import { ReactNode } from "react";
import Header from "../components/Header";
import ReleaseNotes from "../components/ReleaseNotes";
import "./EditorLayout.scss";

const EditorLayout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <div className="editor-layout">
        <Header />
        {children}
      </div>
      <ReleaseNotes />
    </>
  );
};

export default EditorLayout;
